import { Grid, useTheme } from '@mui/material'
import { C1Button } from 'c1ui'
import { C1CheckboxPrettyDisplay } from 'components/core/checkbox'
import { LiveQueryFilter } from 'components/core/search-filter/query'
import { SearchAppsRequest } from 'pbts/c1/api/app/v1/app'
import { useCallback, useEffect, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

type appSearchFilterProps = {
    setAppsFilter: (filter: SearchAppsRequest) => void
}

export const AppSearchFilter = ({ setAppsFilter }: appSearchFilterProps): React.ReactElement[] => {
    const theme = useTheme()
    const intl = useIntl()

    const [query, setQuery] = useState<string>('')
    const [onlyDirectories, setOnlyDirectories] = useState<boolean>(false)

    const changeFilter = useCallback((): void => {
        const filter = SearchAppsRequest.create({
            query,
            onlyDirectories,
        })

        setAppsFilter(filter)
    }, [query, setAppsFilter, onlyDirectories])

    const onQueryChange = useCallback(
        (queryStr: string, loading: boolean): void => {
            setQuery(queryStr)
            if (!loading) {
                changeFilter()
            }
        },
        [changeFilter],
    )

    useEffect(() => {
        changeFilter()
    }, [changeFilter])

    const clear = (): void => {
        setQuery('')
        changeFilter()
    }

    const directories = (isChecked: boolean): void => {
        setOnlyDirectories(isChecked)
        changeFilter()
    }

    const isFiltersSet = (): boolean => {
        return query !== ''
    }

    const getFilters = (): React.ReactElement[] => {
        const filters: React.ReactElement[] = []

        filters.push(
            <Grid key="query" item style={{ marginRight: theme.spacing(3) }}>
                <LiveQueryFilter onChange={onQueryChange} query={query} autoFocus />
            </Grid>,
        )
        if (isFiltersSet()) {
            filters.push(
                <Grid key="clear" item>
                    <C1Button onClick={clear} variant="text" color="info">
                        <FormattedMessage id="components_app_search_index_clear" defaultMessage="Clear" />
                    </C1Button>
                </Grid>,
            )
        }

        filters.push(
            <Grid key="Directory Apps" item>
                <C1CheckboxPrettyDisplay
                    id="components_app_directories_filter"
                    label={intl.formatMessage({
                        id: 'components_app_directories_filter_label',
                        defaultMessage:
                            'Show only directories',
                    })}
                    color="primary"
                    checked={onlyDirectories}
                    onChange={(checkbox): void => {
                        directories(checkbox.target.checked)
                    }}
                />
            </Grid>,
        )

        return filters
    }

    return getFilters()
}
